import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Button, ButtonGroup, UncontrolledTooltip } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getShortcuts, removeShortcut } from '../../AppActions';
import withRouter from '../../../../components/Router/WithRouter';

function ShortcutAccess({ location, dispatch, shortcuts }) {
    const [activeType, setActiveType] = useState(null);

    useEffect(() => {
        setActiveType(null);
    }, [location]);

    const getShortcutsTypes = () => {
        return ['institution', 'user', 'subject', 'session', 'applicant'].filter(type => shortcuts.some(shortcut => shortcut.type === type));
    };

    const renderShortcutIcon = type => {
        switch(type) {
            case 'session':
                return <FontAwesomeIcon icon="paper-plane" />;

            case 'applicant':
                return <FontAwesomeIcon icon="graduation-cap" />;

            case 'subject':
                return <FontAwesomeIcon icon="pen-to-square" />;

            case 'user':
                return <FontAwesomeIcon icon="user" />;

            case 'institution':
                return <FontAwesomeIcon icon="building-columns" />;

            default:
                return null;
        }
    };

    const renderShortcutTypeLinks = shortcut => {
        switch(shortcut.type) {
            case 'session':
                return (
                    <Button color="warning" tag={Link} to={`/console/session/${shortcut.id}/correction`}>
                        <FontAwesomeIcon icon="highlighter" />
                    </Button>
                );

            case 'applicant':
                return (
                    shortcut.reference?.session && (
                        <Button color="warning" tag={Link} to={`/console/session/${shortcut.reference?.session}/correction/applicant/${shortcut.id}`}>
                            <FontAwesomeIcon icon="highlighter" />
                        </Button>
                    )
                );

            case 'subject':
                return (
                    <Fragment>
                        <Button color="primary" outline tag={Link} to={`/console/subject/${shortcut.id}/questions`}>
                            <FontAwesomeIcon icon="list" />
                        </Button>
                        <Button color="primary" tag={Link} to={`/console/subject/${shortcut.id}/preview`}>
                            <FontAwesomeIcon icon="eye" />
                        </Button>
                    </Fragment>
                );

            case 'user':
                return (
                    <Fragment>
                        <Button color="primary" tag={Link} to={`/console/user/${shortcut.id}/history`}>
                            <FontAwesomeIcon icon="clock-rotate-left" />
                        </Button>
                        <Button color="primary" outline tag={Link} to={`/console/user/${shortcut.id}`}>
                            <FontAwesomeIcon icon="eye" />
                        </Button>
                    </Fragment>
                );

            case 'institution':
                return (
                    <Fragment>
                        <Button color="primary" tag={Link} to={`/console/institution/${shortcut.id}`}>
                            <FontAwesomeIcon icon="eye" />
                        </Button>
                        <Button color="success" outline tag={Link} to={`/console/sessions?institution=${shortcut.id}`}>
                            <FontAwesomeIcon icon="paper-plane" />
                        </Button>
                    </Fragment>
                );

            default:
                return null;
        }
    };

    if(shortcuts?.length) {
        return (
            <div className="pt-2">
                <small className="d-block"><em><FormattedMessage id="shortcutsTitle" defaultMessage="Shortcuts" /></em></small>
                {getShortcutsTypes().map((type, index) => (
                    <div key={type} className="position-relative d-inline-block">
                        <span
                            className="position-relative d-block p-1 px-2 bg-white"
                            style={{
                                borderRadius: '0.3rem 0.3rem 0 0',
                                marginBottom: '-0.1rem',
                                ...(type === activeType ? {
                                    zIndex: '9',
                                    borderBottom: 'none',
                                    borderTop: '1px solid #e1e1e1',
                                    borderLeft: '1px solid #e1e1e1',
                                    borderRight: '1px solid #e1e1e1',
                                } : {}),
                            }}
                            onClick={() => setActiveType(newType => (newType === type ? null : type))}
                        >
                            {renderShortcutIcon(type)}
                            {type === activeType && <FontAwesomeIcon icon="times-circle" className="position-absolute text-danger" size="xs" style={{ top: '-5px', right: '-5px' }} />}
                        </span>
                        <div
                            className={classNames('position-absolute', 'z-3', 'bg-white', 'p-2', 'border', 'shadow', activeType !== type && 'd-none')}
                            style={{
                                top: '100%',
                                left: '0px',
                                minWidth: '300px',
                                borderRadius: '0 0.3rem 0.3rem',
                                borderTopWidth: '0',
                                border: '1px solid #e1e1e1',
                            }}
                        >
                            {shortcuts.filter(shortcut => shortcut.type === type).map(shortcut => (
                                <div key={shortcut.id} className="d-flex justify-content-between align-items-center mb-1 pb-1 border-bottom">
                                    <small>{shortcut.label}</small>
                                    <ButtonGroup size="sm">
                                        {renderShortcutTypeLinks(shortcut)}

                                        {/* <Button color="warning" outline id={`shortcut-remove-${shortcut.id}`} onClick={() => dispatch(removeShortcut(shortcut))}>
                                            <FontAwesomeIcon icon="trash-alt" />
                                        </Button>
                                        <UncontrolledTooltip target={`shortcut-remove-${shortcut.id}`}>
                                            <FormattedMessage id="shortcutRemove" defaultMessage="Remove shortcut" />
                                        </UncontrolledTooltip> */}
                                    </ButtonGroup>
                                </div>
                            ))}
                        </div>

                    </div>
                ))}
            </div>
        );
    }
}

ShortcutAccess.propTypes = {
    location: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    shortcuts: PropTypes.array.isRequired,
};

const mapStateToProps = (store, props) => ({
    shortcuts: getShortcuts(store),
});

export default connect(mapStateToProps)(withRouter(ShortcutAccess));
